import { render, staticRenderFns } from "./customer-service.vue?vue&type=template&id=bb3a7d04&scoped=true"
import script from "./customer-service.vue?vue&type=script&lang=js"
export * from "./customer-service.vue?vue&type=script&lang=js"
import style0 from "./customer-service.vue?vue&type=style&index=0&id=bb3a7d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3a7d04",
  null
  
)

export default component.exports